import React, { useState } from "react";
import style from "../constants/style";
import Context from "../Context";
import styled from "styled-components";
import themes from "../themes";
export const StackImages = ({
  urls,
  isShowAllLotto,
  isMagicNumber,
  isDisable = false,
}) => {
  const { configs } = Context();
  const [height, setHeight] = useState(0);

  return (
    <div style={{ position: "relative" }}>
      <div>
        {urls?.length &&
          urls.map((url, i) => (
            <div className="relative" key={i}>
              <Image
                className={isShowAllLotto ? "no-stack" : ""}
                key={i}
                index={i}
                length={urls?.length}
                src={url[0]}
                space={height}
                isDisable={isDisable}
                ref={(el) => el && setHeight(parseInt(el.width * 0.1))}
              />
              <div
                className="absolute flex flex-col justify-start items-center gap-1 top-0 left-0 w-[15%] h-full bg-gold"
                index={i}
              >
                <img
                  src={"/images/logo_single.png"}
                  alt="logo"
                  className="w-full p-1 sm:p-2 pb-0"
                />
                {isMagicNumber && (
                  <img
                    src={configs.magicNumber.image}
                    alt="magin_number"
                    className="w-full"
                  />
                )}

                <p className="text-center px-1 text-navy text-xs font-bold">
                  {urls?.length} ใบ
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

const Tag = styled.div`
  border-radius: 0 0 25px 25px;
  position: absolute;
  width: 15%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  left: 0px;
  top: 0px;

  background: ${themes.colors.primary};
`;

const Image = styled.img`
  left: 0;
  width: 100%;
  margin-top: ${({ index, space }) => index !== 0 && `-${35}%`};
  transition-duration: 0.5s;
  &.no-stack {
    margin-top: 0;
    margin-bottom: 20px;
  }
  :hover {
    margin-bottom: ${({ index, length }) => (index < length - 1 ? "20px" : "")};
    ${style.css.lightShadow};
  }
`;
